// extracted by mini-css-extract-plugin
export default {"error-reference":"error-reference__3HNC-","error-reference__icon":"error-reference__icon__DpZvZ","error-reference__tooltip":"error-reference__tooltip__BCO6_"};